import { render } from "./HiDataListSorter.vue?vue&type=template&id=13733318&scoped=true"
import script from "./HiDataListSorter.vue?vue&type=script&lang=js"
export * from "./HiDataListSorter.vue?vue&type=script&lang=js"

import "./HiDataListSorter.vue?vue&type=style&index=0&id=13733318&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13733318"]])

export default __exports__